import pageData from '@anm/data/video-templates/pages';

import getPageNumberSufix from '../getPageNumberSufix';
import { TemplateMetaProps } from '../types';

const getTemplatesMetaDescription = ({
  pageName,
  pageNumber,
  currentTemplate
}: TemplateMetaProps) => {
  const description = currentTemplate?.templateId
    ? currentTemplate?.description
    : pageData[pageName].header.description_meta;

  const isDotOnEnd = description.endsWith('.');

  const sufix = getPageNumberSufix(pageNumber);

  const clearedDescription =
    isDotOnEnd && sufix
      ? description.substr(0, description.length - 1)
      : description;

  return `${clearedDescription}${sufix}`;
};

export default getTemplatesMetaDescription;
